'use client';
import { LicenseInfo } from '@mui/x-license';

// NEXT_PUBLIC_MUI_X_LICENSE_KEY is inlined at BUILD time. If it's missing
// here it means it was empty in .env.local when `yarn build` ran (e.g. the
// Key Vault secret FE--NEXTPUBLICMUIXLICENSEKEY was empty during deploy).
// Setting it on App Service application settings after the fact will NOT
// fix this — a fresh build + deploy is required.
const licenseKey = process.env.NEXT_PUBLIC_MUI_X_LICENSE_KEY;

if (licenseKey && licenseKey !== 'undefined') {
  LicenseInfo.setLicenseKey(licenseKey);
} else if (typeof window !== 'undefined') {
  console.error(
    '[MUI X] NEXT_PUBLIC_MUI_X_LICENSE_KEY was not set at build time. ' +
      'MUI X Pro components will render with watermarks / throw license errors. ' +
      'Populate FE--NEXTPUBLICMUIXLICENSEKEY in Key Vault and redeploy.',
  );
}

export default function MuiXLicense() {
  return null;
}
